import Header from "./Header";
import Footer from "./Footer";
import MobileStickyBar from "./MobileStickyBar";

export default function Layout({ children }) {
  return (
    <>
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-50 focus:bg-[#1A1A1A] focus:text-white focus:font-bold focus:px-4 focus:py-2 focus:rounded-sm focus:outline focus:outline-2 focus:outline-[#E85D26]"
        data-testid="skip-to-content"
      >
        Skip to main content
      </a>
      <Header />
      <main id="main-content" className="pt-16 md:pt-20">
        {children}
      </main>
      <Footer />
      <MobileStickyBar />
    </>
  );
}
